<template>
  <div class="register">
    <el-card class="box-card" shadow="never" body-style="padding: 0;">
      <TrialZaxis style="background-color: #fff;" sceneCode="6" title="注册"/>
      <div class="login-text">
        <el-button type="text" @click="$router.push(`/login-zaxis?redirect=${redirect}`)">已有账号？立即登录</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import TrialZaxis from '@/components/trialZaxis'

export default {
  components: { TrialZaxis },
  data () {
    return {
      redirect: this.$route.query?.redirect || ''
    }
  }
}
</script>

<style lang='scss' scoped>
.register {
  width: 100vw;
  max-width: Translate(1920px);
  height: Translate(1080px);
  max-height: 100vh;
  background: url('https://images.zzt.com.cn/cdn_file/2026-03-28/login-bg.png')
    no-repeat;
  background-size: cover;
  margin: 0 auto;
  background-position: 0 0;
}

.box-card {
  width: Translate(652px);
  height: Translate(720px);
  margin: 0 auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.login-text {
  position: relative;
  top: Translate(-60px);
}
</style>
